import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MemberTask } from '@/component/Task';
import {
  Close,
  VDialog,
  VFlex,
  VStack,
  VTab,
  VTabContent,
  VTabTrigger,
  VTabTriggerContainer,
  VTextButton,
} from '@/package';
import type { Task } from '@/type';

const enum TAB_VALUE {
  RANGE = 'range',
  RATIO = 'ratio',
}

const WorkRedistributeModalContent = ({
  tabValue,
  task,
  setVisible,
}: {
  tabValue: TAB_VALUE;
  task: Task;
  setVisible: (visible: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [distributeEvenlyTimestamp, setDistributeEvenlyTimestamp] =
    useState(-1);

  const distributeEvenly = async () => {
    setDistributeEvenlyTimestamp(Date.now());
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDistributeEvenlyTimestamp(-1);
  }, [tabValue]);

  return (
    <VStack className="h-[590px] w-[680px] bg-white px-4">
      <VFlex items="center" justify="between" className="py-2">
        <div>{t('task.distributeTitle.mufflin')}</div>
        <Close
          className="size-4"
          role="button"
          onClick={() => setVisible(false)}
        />
      </VFlex>

      <VFlex items="center" className="py-2" justify="between">
        <VTabTriggerContainer>
          <VTabTrigger value={TAB_VALUE.RANGE}>
            {t('task.rangeDistribute.tobaccoweed')}
          </VTabTrigger>
          <VTabTrigger value={TAB_VALUE.RATIO}>
            {t('Ratio allocation')}
          </VTabTrigger>
        </VTabTriggerContainer>

        <VTextButton
          size="sm"
          type="button"
          onClick={() => {
            distributeEvenly();
          }}
        >
          {t('task.distributeEvenly.acquiescement')}
        </VTextButton>
      </VFlex>

      <VTabContent value={TAB_VALUE.RANGE}>
        <MemberTask.RedistributionTableFormWrapper
          distributeEvenlyTimestamp={distributeEvenlyTimestamp}
          task={task}
          onCancel={() => setVisible(false)}
        />
      </VTabContent>

      <VTabContent value={TAB_VALUE.RATIO}>
        <MemberTask.ReallocateRatioTableFormWrapper
          distributeEvenlyTimestamp={distributeEvenlyTimestamp}
          task={task}
          onCancel={() => setVisible(false)}
        />
      </VTabContent>
    </VStack>
  );
};

export const WorkRedistributeModal = ({
  visible,
  setVisible,
  task,
}: {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  task: Task;
}) => {
  const [tabValue, setTabValue] = useState<TAB_VALUE>(TAB_VALUE.RANGE);

  return (
    <VTab
      defaultValue={tabValue}
      size="sm"
      value={tabValue}
      onValueChange={v => {
        setTabValue(v as TAB_VALUE);
      }}
    >
      <VDialog visible={visible} onUpdateVisible={setVisible}>
        <WorkRedistributeModalContent
          tabValue={tabValue}
          task={task}
          setVisible={setVisible}
        />
      </VDialog>
    </VTab>
  );
};
